import React from 'react'

import Select from 'components/fields/Select'

type Props = {
	label: string
	value: string
	name: string
	options: {
		value: string
		label: string
	}[]
	onChange: (value: string) => void
	disabled?: boolean
}

const SelectField: React.FC<Props> = ({ label, value, name, options, onChange, disabled, ...restProps }) => {
	const fieldId = React.useId()

	return (
		<>
			<label htmlFor={fieldId}>{label}</label>
			<Select
				id={fieldId}
				value={value}
				name={name}
				onChange={(event) => onChange(event.target.value)}
				disabled={disabled}
				{...restProps}
			>
				{options.map(({ value, label }, idx) => (
					<option key={idx} value={value}>
						{label}
					</option>
				))}
			</Select>
		</>
	)
}

export default SelectField
